module.exports = __webpack_public_path__ + "static/img/s_peeling.d798600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/s_peeling.jpg
// module id = 103
// module chunks = 1